import React from 'react';
import ReactDOM from 'react-dom';
import client from './client-side-apollo-client';
import {createStore} from './store';
import AppContainer from 'react-hot-loader/lib/AppContainer';
import Root from './Root';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Initial state as set by the server-side render
const initialState = window.__INITIAL_STATE__;
const store = createStore(initialState);

ReactDOM.hydrate(
    <AppContainer store={store}>
        <Root store={store} client={client}/>
    </AppContainer>,
    document.getElementById('root')
);

// Hot module replacement in development env only
if (module.hot) {
    module.hot.accept('./Root', () => {
        const RootRequired = require('./Root').default;
        ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        ReactDOM.hydrate(
            <AppContainer store={store}>
                <RootRequired store={store} client={client}/>
            </AppContainer>,
            document.getElementById('root')
        );
        console.log(`[HMR] Rendered at ${new Date().toLocaleTimeString()}`); // eslint-disable-line
    });
}



// WEBPACK FOOTER //
// ./src/universal/index.js